export function readCookie(name: string): string | undefined {
  if (typeof document === "undefined") {
    return undefined;
  }

  let cookieString: string;
  try {
    cookieString = document.cookie;
  } catch {
    return undefined;
  }

  const cookiePrefix = `${name}=`;
  const cookie = cookieString
    .split(";")
    .map((row) => row.trim())
    .find((row) => row.startsWith(cookiePrefix));
  const value = cookie?.slice(cookiePrefix.length);

  if (!value) {
    return undefined;
  }

  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
